export default __webpack_public_path__ + "static/SR India - Safety Data Sheet - Caramel Color (Liquid)-46361e9f94909270b140815578e05498.pdf";